import * as createjs from 'createjs-module';
// import * as $ from 'jquery';
import { AppGlobals } from '../../shared/app.global';
import { Component,ViewEncapsulation,Input } from '@angular/core';
import { interActivityServices } from '../../shared/services/interactivity.services';
import { InteractiveComponent } from '../../components/interactivity/interactivity.component';
import * as activityDataObj from '../../shared/content/activityData.json';

declare var $: any;

@Component({
  selector: 'app-video',
  template: `
  <div class="videoParent">
  <video src="{{commonData.videoSrc}}" id="myVideo" width="1024" height="498"></video>
  <div class="videoPoster"></div>
  </div>
  `,
  // template: `<video [class.hidden]= "!interactivyService.isShowVideo" src="{{interactivyService.videoSrc}}" id="myVideo" width="740" height="570"></video>`,
})

export class VideoControllerComponent{
  public videoElement= null;
  public commonData = (<any>activityDataObj).commonData;


  constructor(
    public appGlobal: AppGlobals,
    public interactivyService: interActivityServices,
    public interactivty: InteractiveComponent) {
    }
  createVideoTag(){
    this.interactivyService.videoElement = document.getElementById('myVideo');
    this.interactivyService.videoElement.preload = "auto";
    this.interactivyService.videoElement.type = 'video/mp4'
    this.interactivyService.videoElement.loop = false;
  }
  showVideo(){
  }
  ngAfterViewInit(){
    var self = this;
    this.createVideoTag()
    //self.playVideo();
    $('.videoPoster').show();

  }
  setVideosrc(_poster,source): void {
    this.interactivyService.videoElement.poster = _poster;
    this.interactivyService.videoElement.src = source;
  }
  playPauseAudio(event): void {
    // this.interactivyService.isVideoPlaying ? this.playVideo():this.pauseVideo();
  }

  playVideo(){
    var self = this;
    self.interactivyService.videoElement.play();
    this.interactivyService.videoElement.onended = function () {
          self.pauseVideo();
          self.interactivyService.isShowPlay = true;
          self.interactivyService.isVideoEnded = true;
    }
    this.interactivyService.videoElement.ontimeupdate = function(event){
      if (self.interactivyService.videoElement.currentTime >= 0 && self.interactivyService.isShowStartBg){
          self.pauseVideo();
        }
        if (self.interactivyService.videoElement.currentTime > 0.1) {
          //if ($('.videoPoster').is(":visible")){
          //  self.interactivyService.videoElement.currentTime = 0.3;
          //}
          $('.videoPoster').hide();
        }
        let evt = new CustomEvent('videoValuechanged', {
          detail: {
            "time": self.interactivyService.videoElement.currentTime
          }
        });
        document.dispatchEvent(evt)
    }
  }
  pauseVideo(){
    this.interactivyService.videoElement.pause();
  } 


























}
